import { template as template_9aa87a86a2ea485885a38837ebff9b42 } from "@ember/template-compiler";
import { hash } from '@ember/helper';
const BlankTemplate = template_9aa87a86a2ea485885a38837ebff9b42(`
<div ...attributes>
  {{yield}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default template_9aa87a86a2ea485885a38837ebff9b42(`
  {{yield
    (hash
      taskDetails=BlankTemplate
    )
  }}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
